var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-chat-message LyMe",staticStyle:{"width":"auto"}},[_c(_vm.isComponent(_vm.data),{tag:"component",attrs:{"data":_vm.data},on:{"action":_vm.onAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }